import { useFormContext } from 'react-hook-form';
import { useQuery } from 'react-query';
import { useTranslation } from 'react-i18next';
import {
  DIGITAL_FAIR_VALUE_KEY,
  getDivisions,
} from 'api/services/mediaPlanning/mediaPlanning';
import { SelectChangeEvent } from '@mui/material';
import { useParams } from 'react-router-dom';
import { FormSelect } from '../../../common/FormSelect/FormSelect';
import usePlanStore from '../../../../../../store/planStore';

export default function DivisionSelect() {
  const { t } = useTranslation();
  const { control } = useFormContext();

  const { generalInfoState, setGeneralInfoState } = usePlanStore((state) => ({
    generalInfoState: state.generalInfoState,
    setGeneralInfoState: state.setGeneralInfoState,
  }));

  const { id } = useParams();

  const { data: divisionsResponse, isFetching } = useQuery(
    [DIGITAL_FAIR_VALUE_KEY, 'divisions'],
    getDivisions
  );

  const divisions = (divisionsResponse?.data.divisions || []).map(
    (division) => division
  );

  return (
    <FormSelect
      name="divisions"
      control={control}
      options={divisions}
      value={generalInfoState.division}
      label={t('Division')}
      fullWidth
      isLoading={isFetching}
      isDisabled={isFetching || !!id}
      onChange={(event: SelectChangeEvent<unknown>) => {
        setGeneralInfoState({
          division: event.target.value as string,
          brand: undefined,
          category: undefined,
        });
      }}
    />
  );
}
